import React, { memo } from 'react';
import { Text, Link, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const ProductInfoRow = memo(({ label, value, onClick, hide }) => {
    const theme = useTheme();
    const isLink = onClick && value;
    if (hide) return null;
    return (
        <div className="fm-products-detail__info-row">
            <Text type="body" color={theme.colors.utility.textSecondary}>
                {getLiteral(label)}:
            </Text>
            {isLink && (
                <Link
                    className="fm-products-detail__info-row__value"
                    type="body"
                    onClick={onClick}
                    isTruncated
                    useTooltip
                >
                    {value ? value : '-'}
                </Link>
            )}
            {!isLink && (
                <Text
                    className="fm-products-detail__info-row__value"
                    type="body"
                    isTruncated
                    useTooltip
                >
                    {value ? value : '-'}
                </Text>
            )}
        </div>
    );
});

export default ProductInfoRow;
